import { useEffect, useRef, useState } from "react";
import { world_to_screen } from "../utils/math";
import { BombData } from "../utils/types";

interface SVGBombProps {
  data: BombData,
  mapName: string,
  mapInfo: { [key: string]: any },
  upperView: boolean,
  currentTick: number,
  scaleFactor: number,
  bombPlanted: boolean,
  bombDefusing: boolean,
  bombTimeLeft: number,
}

export const SVGBomb = ({ data, mapName, mapInfo, upperView, currentTick, scaleFactor, bombPlanted, bombDefusing, bombTimeLeft }: SVGBombProps) => {
  const [boxSize, setBoxSize] = useState({ width: 0, height: 0 });

  const textRef = useRef<SVGTextElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const bbox = textRef.current.getBBox();
      setBoxSize({ width: bbox.width + 10, height: bbox.height + 2 });
    }
  }, [textRef]);
  
  const mainPath = "m0.4591-0.26638c0.008635 0.01077 0.012995 0.023734 0.012995 0.038895v0.48474c0 0.014063-0.004331 0.025959-0.012995 0.03572-0.009731 0.011808-0.022726 0.0178-0.038894 0.0178h-0.84141c-0.014091 0-0.026493-0.005967-0.037322-0.017861-0.01077-0.009761-0.016228-0.021628-0.016228-0.03572v-0.48471c0-0.015101 0.005458-0.028095 0.016228-0.038895 0.010828-0.01077 0.02323-0.016198 0.037322-0.016198h0.84141c0.016169 0 0.029134 0.005428 0.038894 0.016228";
  const extraPath = "m0.025378-0.21564c-0.0043314 0-0.0080948 0.001608-0.011358 0.004806l-0.0064906 0.013037v0.22691l0.0064906 0.012978 0.011358 0.0032439h0.35509c0.011808 0 0.01779-0.0054003 0.01779-0.016224v-0.22691c0-0.011896-0.006013-0.017846-0.017846-0.017846zm-0.17998 0.22853-0.0908 0.14759v0.037317h0.1054v0.056728h0.053483v-0.056728h0.030827v-0.042184h-0.030827v-0.14272zm0.014601 0.042242h0.003245l-0.001626 0.024279-0.001687 0.022715v0.053483h-0.051861l0.029204-0.053483 0.012981-0.022715zm-0.16375 0.014601c-0.034593 0-0.061078 0.0091832-0.079442 0.027581-0.016228 0.017296-0.024279 0.039407-0.024279 0.066405 0 0.029134 0.00805 0.052441 0.024279 0.069708 0.016228 0.016228 0.039447 0.024337 0.069708 0.024337l0.029204-0.003244 0.021092-0.00487-0.004868-0.043749-0.016224 0.006488h-0.017846c-0.012995 0-0.024342-0.004378-0.034014-0.012981-0.010828-0.007622-0.016224-0.020021-0.016224-0.037317 0-0.012964 0.004871-0.024253 0.014601-0.034013 0.007535-0.010827 0.019409-0.016224 0.035636-0.016224l0.017846 0.001571 0.012981 0.0033 0.009736-0.040504-0.019469-0.0048705zm0.33237 0.006432-0.011358 0.0032438-0.0065482 0.011358v0.045371l0.0065482 0.009677c0.0043016 0.00436 0.0080948 0.006553 0.011358 0.006553h0.043748l0.011358-0.006553 0.0048678-0.009677v-0.04537l-0.0048678-0.011358-0.011358-0.0032438zm0.10048 0-0.009736 0.0032438-0.004806 0.011358v0.045371l0.004806 0.009677 0.009794 0.006553h0.045371l0.011358-0.006553 0.003244-0.009677v-0.04537l-0.003244-0.011358-0.011414-0.0032439zm0.10053 0-0.009736 0.0032438c-0.003235 0.004304-0.00487 0.008096-0.00487 0.011358v0.045371l0.00487 0.009677 0.009736 0.006553h0.046994l0.009792-0.006553 0.003244-0.009677v-0.04537l-0.003299-0.011358-0.009736-0.0032439zm0.10216 0-0.011414 0.0032438-0.004806 0.011358v0.045371l0.004806 0.009677 0.011414 0.006553h0.043749l0.011358-0.006553 0.00487-0.009677v-0.04537l-0.00487-0.011358-0.011358-0.0032438zm-0.20263 0.10534c-0.004332 0-0.007593 0.002129-0.009794 0.006488-0.003235 0.00211-0.004806 0.0054-0.004806 0.009736v0.045371l0.004806 0.011414 0.009794 0.003244h0.045371l0.011358-0.003244 0.003244-0.011414v-0.045371l-0.003244-0.009736-0.011358-0.006488zm0.20263 0-0.011358 0.006488c-0.00329 0.002138-0.004806 0.005466-0.004806 0.009794v0.045313l0.004806 0.011414 0.011358 0.003244h0.043806l0.0113-0.003244 0.00487-0.011414v-0.045372l-0.00487-0.009736-0.011358-0.006488zm-0.30317 5.642e-5c-0.0032327 0-0.0070547 0.002072-0.011358 0.006432l-0.0065482 0.009794v0.045371l0.0065482 0.011358 0.011358 0.003244h0.043748l0.011358-0.003244 0.0048678-0.011358v-0.045371l-0.0048678-0.009736-0.011358-0.006488zm0.20101 0-0.009736 0.006488c-0.003235 0.002138-0.004806 0.0054-0.004806 0.009736v0.045372l0.004806 0.011358 0.009792 0.003244h0.046935l0.009792-0.003244 0.003244-0.011358v-0.045369l-0.003299-0.009736-0.009736-0.006488z";
  const position = world_to_screen([data.x, data.y, data.z], mapName);
  
  const totalBombTime = 64 * 40; // Total bomb time in ticks
  const oscillationFactor = 1.75; // Adjust this factor to control the overall oscillation frequency
  const angle = (totalBombTime - bombTimeLeft) / (totalBombTime / oscillationFactor) + 1;
  
  const t = bombPlanted && !bombDefusing 
      ? Math.max(Math.sin(angle * angle * angle * angle * angle) * 64, 0)
      : 0;
  
  const s = 0.1;

  const mInfo = mapInfo[mapName as keyof typeof mapInfo];
  const zOpacity = (data.z - mInfo.minZ) / (mInfo.maxZ - mInfo.minZ);
  const opacity = Math.min(Math.max(upperView ? zOpacity : 1.0 - zOpacity, 0.2), 1.0);

  let color = [255, 157, 16, opacity]
  color = [color[0] + t * 2, color[1] + t, color[2] + t * 1.5, color[3]];
  let stroke: number[] = [color[0] * s, color[1] * s, color[2] * s, color[3]];
  let shadow = [0, 0, 0, 0.2 * opacity];

  const size = 25 / scaleFactor;
  const extraColor = [0, 0, 0, color[3]];

  const textColor = [0, 0, 0, opacity];
  const text = Math.round(bombTimeLeft / 64.0);

  return (
    <svg key={`bomb_wrapper`}>
      <path
        id={`bomb_bg_shadow`}
        fill={`rgba(${shadow[0]}, ${shadow[1]}, ${shadow[2]}, ${shadow[3]})`}
        transform={`translate(${position[0] + size * 0.1}, ${position[1] + size * 0.1}) scale(${size})`}
        d={mainPath}
      />
      <path
        id={`bomb_bg_stroke`}
        stroke={`rgb(${stroke[0]}, ${stroke[1]}, ${stroke[2]}, ${stroke[3]})`}
        strokeWidth={0.1}
        fill="none"
        transform={`translate(${position[0]}, ${position[1]}) scale(${size})`}
        d={mainPath}
      />
      <path
        id={`bomb_bg`}
        fill={`rgb(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`}
        transform={`translate(${position[0]}, ${position[1]}) scale(${size})`}
        d={mainPath}
      />
      <path
        id={`bomb`}
        fill={`rgb(${extraColor[0]}, ${extraColor[1]}, ${extraColor[2]}, ${extraColor[3]})`}
        transform={`translate(${position[0]}, ${position[1]}) scale(${size})`}
        d={extraPath}
      />
      {bombPlanted && <>
      <path
        id={`bomb_bg`}
        fill={`rgb(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`}
        transform={`translate(${position[0]}, ${position[1]}) scale(${size})`}
        d={mainPath}
      />
      <path
        id={`bomb_bg_stroke`}
        stroke={`rgb(${stroke[0]}, ${stroke[1]}, ${stroke[2]}, ${stroke[3] * 0.25})`}
        strokeWidth={0.1}
        fill="none"
        transform={`translate(${position[0]}, ${position[1]}) scale(${size})`}
        d={mainPath}
      />
      <text
        ref={textRef}
        transform={`translate(${position[0]}, ${position[1] + size * 0.025}) scale(${size * 0.042})`}
        id={`bomb_timer`}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={9.0}
        fill={`rgba(${textColor[0]}, ${textColor[1]}, ${textColor[2]}, ${textColor[3]})`}
        x={0}
        y={0.5}
      >
        {text}
      </text>
      </>}
    </svg>
  );
}
